<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>退款撤销列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--面包屑导航区域-->
    <!--卡片视图区-->
    <el-card>
      <!--搜索与添加区域-->
      <el-row :gutter="20">
        <el-col :span="20">
          <el-input
            placeholder="请输入商户编号"
            clearable
            v-model="queryInfo.payOrderno"
            @clear="getOrderList()"
            style="width: 300px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-input
            placeholder="请输入订单编号"
            clearable
            v-model="queryInfo.orderno"
            @clear="getOrderList()"
            style="width: 300px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-select
            v-model="queryInfo.storeId"
            placeholder="请选择门店"
            @change="getOrderList()"
            style="margin-left: 10px"
            clearable
            filterable
          >
            <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model="customdate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="CustomeDate"
            style="margin: 0 10px"
          >
          </el-date-picker>
          <el-select
            v-model="queryInfo.cardForm"
            clearable
            placeholder="请选择交易类型"
            @change="getOrderList()"
            style="width: 150px"
          >
            <el-option label="平台" value="0"></el-option>
            <el-option label="抖音" value="1"></el-option>
            <el-option label="美团" value="2"></el-option>
            <el-option label="高德" value="7"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <br />
      <!--搜索与添加区域-->
      <!--用户列表区域-->
      <el-table
        :data="orderlist"
        style="width: 100%"
        ref="invoiceTable"
        stripe
        size="small"
        height="760"
        show-summary
        v-loading="isLoading"
        :row-class-name="tableRowClassName"
        :row-key="row => row.id"
      >
        <!-- <el-table-column label="ID" type="index"  width="50" fixed></el-table-column> -->
        <el-table-column label="序号" width="50" fixed>
          <template slot-scope="scope">
            {{
              (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="商户编号"
          prop="payOrderno"
          min-width="110"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="订单编号"
          prop="orderno"
          min-width="110"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="用户名"
          prop="username"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="店铺名"
          prop="storename"
          min-width="90"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="卡名"
          prop="cardname"
          min-width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="支付金额"
          prop="price"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope" v-if="scope.row.price">
            <span style="color: #ff0000">￥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="撤销金额"
          prop="sendPrice"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.sendPrice"
              >￥{{ scope.row.sendPrice }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="来源"
          prop="cardForm"
          min-width="80"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.cardForm == '0'">平台</el-tag>
            <el-tag type="danger" v-if="scope.row.cardForm == '1'">抖音</el-tag>
            <el-tag type="warning" v-if="scope.row.cardForm == '2'">美团</el-tag>
            <el-tag v-if="scope.row.cardForm == '7'">高德</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="撤销状态"
            prop="isAudit"
            min-width="80"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
                type="warning"
                v-if="scope.row.isAudit == '1'"
            >审核中</el-tag>
            <el-tag
                type="success"
                v-if="scope.row.isAudit == '2'"
            >审核成功</el-tag>
            <el-tag
                type="danger"
                v-if="scope.row.isAudit == '3'"
            >审核失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="撤销原因"
            prop="auditReason"
            min-width="130"
            :show-overflow-tooltip="true"
        />
        <el-table-column
            label="拒绝原因"
            prop="auditError"
            min-width="130"
            :show-overflow-tooltip="true"
        />
        <el-table-column
          label="撤销发起时间"
          prop="cxSendTime"
          min-width="130"
        />
        <el-table-column
          label="撤销审核时间"
          prop="cxAuditTime"
          min-width="130"
        />
        <el-table-column label="操作" min-width="240" >
          <template slot-scope="scope">
            <span v-if="scope.row.isAudit == '1'">
              <el-button type="warning" icon="el-icon-edit" size="mini"
                  @click="sxCard(scope.row)">审核</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!--用户列表区域-->
      <!--分页区域-->
      <br />
      <div align="center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20, 50, 100]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination> -->
      </div>
    </el-card>


    <!--审核对话框-->
    <el-dialog
        title="撤销审核"
        :visible.sync="refundDialogVisible"
        width="65%"
        @close="refundDialogClosed"
    >
      <el-form
          :model="refundForm"
          :rules="refundFormRules"
          ref="refundFormRef"
          label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商户单号">
              {{ refundForm.payOrderno }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额">
              {{ refundForm.price }} 元
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="可撤销金额">
              {{ (refundForm.price - refundForm.cxPrice).toFixed(2) }} 元
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="撤销金额">
              {{ refundForm.sendPrice }} 元
            </el-form-item>
          </el-col>
        </el-row>
          <el-form-item label="撤销说明">
            {{refundForm.auditReason}}
          </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="refundForm.isAudit" @change="handleChangeStatus">
                <el-radio :label="2">同意</el-radio>
                <el-radio :label="3">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="拒绝原因" prop="auditError" v-if="refundForm.status == 3">
              <el-input
                  type="textarea"
                  v-model="refundForm.auditError"
                  placeholder="请输入拒绝原因"
                  :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefund">确 定</el-button>
      </span>
    </el-dialog>
    <!--退款对话框-->
  </div>
</template>
<script>
import axios from "axios";
import {saveAs} from "file-saver";
import {Loading} from "element-ui";

export default {
  data() {
    return {
      refundForm: {
        payOrderno: "",
        price: 0, // 订单金额
        cxPrice: null, // 撤销金额
        sendPrice: null,
        auditReason: "", // 撤销说明
        auditError: "", // 拒绝原因
        status: 0
      },
      // 退款表单验证规则
      refundFormRules: {
        auditError: []
      },
      refundDialogVisible: false,
      exporting: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      customdate: "",
      //获取订单列表的参数对象
      queryInfo: {
        payOrderno: "",
        orderno: "",
        cardForm: "",
        storeId: "", // 添加申请退款搜索参数
        startTime: "",
        endTime: "",
        isAudit: '1',
        pagenum: 1,
        pagesize: 20,
      },
      orderlist: [],
      storelist: [],
      total: 0,
      loading: false,
      isLoading: true
    };
  },
  created() {
    this.getOrderList();
    this.GetStore();
  },
  methods: {
    async GetStore() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    async getOrderList() {
      this.isLoading = true
      // 先清空列表，避免 Vue 虚拟 DOM 更新冲突
      this.orderlist = [];
      this.queryInfo.pagenum = 1
      try {
        const { data: res } = await this.$http.post("sendPay/getList", this.queryInfo);

        // 检查响应状态和数据是否存在
        if (res.status == 1) {
          if (res.data.totalCount > 0) {
            this.total = res.data.totalCount;
          }

          // 处理订单列表数据
          if (res.data.list && Array.isArray(res.data.list)) {
            // 使用 $nextTick 确保 DOM 更新完成后再赋值
            this.$nextTick(() => {
              this.orderlist = res.data.list;
              this.isLoading = false;
            });
          } else {
            this.orderlist = [];
            this.isLoading = false;
          }
        } else {
          // 请求失败或数据格式不正确
          this.total = 0;
          this.orderlist = [];
          this.isLoading = false;
          if (res && res.message) {
            this.$message.error(res.message);
          }
        }
        console.log("订单列表数据:", this.orderlist);
      } catch (error) {
        this.isLoading = false;
        this.total = 0;
        this.orderlist = [];
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败");
      }
    },
    async getFyOrderList() {
      this.isLoading = true
      const { data: res } = await this.$http.post("sendPay/getList", this.queryInfo);
      this.isLoading = false
      if (res.status == 1) {
        if (res.data.totalCount > 0) {
          this.total = res.data.totalCount;
        }

        // 处理订单列表数据
        this.orderlist = res.data.list
      }
      this.isLoading = false;
      console.log("订单列表数据:", this.orderlist);
    },
    handleSizeChange(newSize) {
      this.isLoading = true;
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getFyOrderList();
    },
    handleCurrentChange(newPage) {
      this.isLoading = true;
      // console.log(newPage)
      this.queryInfo.pagenum = newPage;
      this.getFyOrderList();
    },
    CustomeDate() {
      // console.log(this.customdate);
      if (this.customdate == null) {
        this.queryInfo.startTime = "";
        this.queryInfo.endTime = "";
      } else {
        this.queryInfo.startTime = this.customdate[0];
        this.queryInfo.endTime = this.customdate[1];
      }
      this.getOrderList();
    },
    // 导出订单数据
    exportOrders() {
      if (!this.queryInfo.startdate || !this.queryInfo.enddate) {
        this.$message.warning('请选择日期范围')
        return
      }
      const start = new Date(this.queryInfo.startdate)
      const end = new Date(this.queryInfo.enddate)
      const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24))
      if (diffDays > 31) {
        this.$message.error('日期范围不能超过31天')
        return
      }
      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .get("/orderAllList/export", {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          responseType: "blob",
          params: this.queryInfo,
        })
        .then(async (data) => {
          const isBlob = data.data.type !== "application/json";
          if (isBlob) {
            const blob = new Blob([data.data]);
            saveAs(blob, `订单数据_${new Date().getTime()}.xlsx`);
          } else {
            this.$message.error("导出订单数据失败");
          }
          downloadLoadingInstance.close();
        })
        .catch((r) => {
          console.error(r);
          this.$message.error("下载文件出现错误，请联系管理员！");
          downloadLoadingInstance.close();
        });
    },
    // 设置表格行的类名
    tableRowClassName({ row }) {
      // 同时满足 doutuiflag=1 和 status=0 的条件才显示浅红色背景
      if (row.doutuiflag == 1 && row.status == 0) {
        return "doutuiflag-row";
      }
      return "";
    },
    async sxCard(row) {
      // 设置退款对话框数据
      this.refundForm = {
        payOrderno: row.payOrderno,
        price: row.price || 0, // 订单金额
        cxPrice: row.cxPrice, // 撤销金额，用户输入
        sendPrice: row.sendPrice, // 撤销金额，用户输入
        auditReason: row.auditReason, // 撤销说明，用户输入
        auditError: null,
        isAudit: 2
      };
      this.refundDialogVisible = true;
    },
    refundDialogClosed() {
      this.$refs.refundFormRef.resetFields();
      // 重置退款表单
      this.refundForm = {
        payOrderno: "",
        price: 0, // 订单金额
        cxPrice: null, // 撤销金额
        sendPrice: null, // 撤销金额
        auditReason: "", // 撤销说明
        auditError: "", // 拒绝原因
        isAudit: 2
      };
    },
    // 提交撤销
    async submitRefund() {
      // 验证表单
      this.$refs.refundFormRef.validate(async (valid) => {
        if (!valid) return;

        // 再次确认
        const confirmResult = await this.$confirm(
            "确定要对此订单进行审核吗？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
        ).catch((err) => err);

        if (confirmResult !== "confirm") {
          return this.$message.info("已取消撤销！");
        }

        if (this.refundForm.sendPrice < 1) {
          return this.$message.error("撤销金额最少1元");
        }

        // 发送撤销请求
        const { data: res } = await this.$http.post("sendPay/auditSubmit", this.refundForm);

        if (res.code == 200) {
          this.refundDialogVisible = false;
          this.$message.success(res.msg)
          await this.getOrderList()
        } else {
          this.$message({ message: res.msg || "撤销失败！", type: "error" });
        }
      });
    },
    handleChangeStatus(status) {
      this.refundForm.auditError = null
      this.refundFormRules.auditError = []
      if (status == 3) {
        this.refundFormRules.auditError = [
          { required: false, message: "请输入撤销说明", trigger: "blur" },
        ]
      }
    }
  },
};
</script>
<style scoped>
.cardcss {
  margin: 5px auto;
  width: 100%;
}
.el-breadcrumb {
  width: 100%;
}
</style>

<!-- 全局样式，不使用scoped，确保可以影响el-table内部元素 -->
<style>
/* 允许表格内容被选择和复制 */
.el-table {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

.el-table__body-wrapper {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

.el-table__body tr,
.el-table__body td {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

/* doutuiflag=1且status=0的行显示浅红色背景 */
.el-table .doutuiflag-row {
  background-color: #ffebeb !important;
}

/* 鼠标悬停时的样式 */
.el-table .doutuiflag-row:hover > td {
  background-color: #ffe0e0 !important;
}

/* 时效卡弹窗样式 */
.gift-card-dialog .el-dialog__header {
  background-color: #f56c6c;
  padding: 15px 20px;
}

.gift-card-dialog .el-dialog__title {
  color: white;
  font-weight: bold;
}

/* 赠卡记录弹窗样式 */
.gift-record-dialog .el-dialog__header {
  background-color: #409eff;
  padding: 15px 20px;
}

.gift-record-dialog .el-dialog__title {
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.gift-card-dialog .el-dialog__body {
  padding: 30px 20px;
}

.gift-card-dialog .el-button--primary {
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.gift-card-dialog .el-button--primary:hover,
.gift-card-dialog .el-button--primary:focus {
  background-color: #f78989;
  border-color: #f78989;
}

.gift-card-dialog .duration-input .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
